import { render, staticRenderFns } from "./entrust.vue?vue&type=template&id=24004b03&scoped=true&"
import script from "./entrust.vue?vue&type=script&lang=ts&"
export * from "./entrust.vue?vue&type=script&lang=ts&"
import style0 from "./entrust.vue?vue&type=style&index=0&id=24004b03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24004b03",
  null
  
)

export default component.exports